import Vue from 'vue'
import VueI18n from 'vue-i18n'
import * as l from "../../../../builder/src/locale/index";
import lambda_mn from "../../../../builder/src/locale/mn_MN";
import lambda_en from "../../../../builder/src/locale/en_US";
import lambda_kr from "../../../../builder/src/locale/ko_KR";
import app_mn from "../../../public/i18n/mn_mn.json";
import app_en from "../../../public/i18n/en_us.json";
import app_kr from "../../../public/i18n/ko_kr.json";

Vue.use(VueI18n)

const messages = {
    'mn_MN': {
        ...lambda_mn,
        ...app_mn
    },
    'en_US': {
        ...lambda_en,
        ...app_en
    },
    'ko_KR': {
        ...lambda_kr,
        ...app_kr
    }
}

export const i18n = new VueI18n({
    locale: 'mn_MN', // set locale
    fallbackLocale: 'mn_MN',
    messages
})

const loadedLanguages = ['mn_MN','en_US','ko_KR'];

export const setI18nLanguage = (lang) => {
    i18n.locale = lang
    return lang
}

export const loadLanguageAsync = (lang) => {
    localStorage.setItem("lang", lang);
    l.loadLanguageAsync(lang);

    // If the same language
    if (i18n.locale === lang) {
        return Promise.resolve(setI18nLanguage(lang))
    }

    // If the language was already loaded
    if (loadedLanguages.includes(lang)) {
        return Promise.resolve(setI18nLanguage(lang))
    }

    // if (window.lambda && window.lambda.static_words && window.lambda.static_words[lang]) {
    //     i18n.setLocaleMessage(lang, {auth: window.lambda.static_words[lang]});
    //     loadedLanguages.push(lang)
    //     return setI18nLanguage(lang)
    // } else {
    //     // return import(`./${lang}`).then(
    //     //     messages => {
    //     //         i18n.setLocaleMessage(lang, messages.default)
    //     //         loadedLanguages.push(lang)
    //     //         return setI18nLanguage(lang)
    //     //     }
    //     // )
    // }
}
